import { render, staticRenderFns } from "./SupplementReviewList.vue?vue&type=template&id=150afc7e&scoped=true&"
import script from "./SupplementReviewList.vue?vue&type=script&lang=js&"
export * from "./SupplementReviewList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementReviewList.vue?vue&type=style&index=0&id=150afc7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150afc7e",
  null
  
)

export default component.exports